export default __webpack_public_path__ + "static/media/tickets.4eac7c08.JPG";